import { findCustomFrontendApp } from '../custom-frontend/customFrontendManifest';
import { AppMetadata, IAppMetadataInfo } from './persistent-iframe.constants';

// Kept out of persistent-iframe.constants to avoid the
// store→reducer→constants→manifest→store import cycle.
export function getAppMetadata(appName: string): IAppMetadataInfo | undefined {
    if (AppMetadata[appName]) return AppMetadata[appName];

    const app = findCustomFrontendApp(appName);
    if (!app) return undefined;

    const params = new URLSearchParams({
        source: 'transporter_portal', // required — omitting it throws SourceMissingError in the embedded SPA
        appId: app.appId,
    });
    return {
        iframeId: `persistent-iframe-custom-${app.appId}`,
        origin: app.url,
        url: `${app.url}?${params.toString()}`,
        basePath: '',
        passCredentials: true,
    };
}
